export default __webpack_public_path__ + "static/crypto-2-ef3d7f0812dea151655f6c17984d44d2.svg";